import { Pipe, PipeTransform } from '@angular/core';
import { readStory } from '../interfaces/story';

@Pipe({ name: 'filterStoriesByType' })
export class FilterStoriesByTypePipe implements PipeTransform {

  transform(stories: readStory[], type: string): readStory[] {
    if (!type || type === 'all') return stories;
    return stories.filter(story => story.type === type);
  }

}
